<template>
  <div>
    <BaseLabel
      v-if="label"
      class="mb-1"
    >
      {{ label }}
    </BaseLabel>
    <div class="flex">
      <input
        v-bind="$attrs"
        :id="computedLabel"
        :value="value"
        :class="{'flex-1': !small, 'mr-4': small}"
        class="outline-none input border-solid
        border-shadow-color border-b focus:border-orange pb-2
        text-lg font-sans-medium custom-min-width"
        @input="$emit('input', $event.target.value)"
      >
      <BaseButton
        v-if="withDeleteButton"
        :title="$t('Remove')"
        theme="secondary"
        @click.native="$emit('remove')"
      />
    </div>
  </div>
</template>

<script>
import BaseLabel from './BaseLabel.vue';
import BaseButton from './BaseButton.vue';

export default {
  name: 'BaseInputGroup',
  components: {
    BaseLabel,
    BaseButton,
  },
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    small: {
      type: Boolean,
      default: false,
    },
    withDeleteButton: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computedLabel() {
      if (this.label) {
        return this.label.replace(/ /g, '');
      }
      return this.label;
    },
  },
};
</script>

<style land="scss" scoped>
.custom-min-width {
  min-width: 150px;
}
</style>
